import React, { useState, useEffect } from 'react';
import mp3File from '../../../../resources/sound.mp3';
import styles from './Header.module.css';
import constants from './constants';
import Tooltip from "rc-tooltip";

import option from "../../../../assets/images/Fireboard/option.png";
import resyncImg from '../../../../assets/images/Fireboard/resync.png';
import search from '../../../../assets/images/Fireboard/search_white.png';
import calendarImage from '../../../../assets/images/Fireboard/calendar_white.png';
import unpaidIcon from '../../../../assets/images/Fireboard/unpaid.png';
import snooze from '../../../../assets/images/Fireboard/snoozeSleep.png';
import notificationGif from '../../../../assets/images/Fireboard/bell.gif';
import logoutImage from '../../../../assets/images/logout/logout.png';
import notificationUnSelectedUnFilled from '../../../../assets/images/Fireboard/notificationfilled_white.png';
import notificationUnSelectedFilled from '../../../../assets/images/Fireboard/notificationfilled_orange.png';
import graphicalImg from '../../../../assets/images/Fireboard/graphical-view.png';

import channels from '../../../../assets/images/Fireboard/menu_buttons/channels.png';
import filters from '../../../../assets/images/Fireboard/menu_buttons/filters.png';
import info from '../../../../assets/images/Fireboard/menu_buttons/info.png';
import outofstock from '../../../../assets/images/Fireboard/menu_buttons/outofstock.png';
import pairwatch from '../../../../assets/images/Fireboard/menu_buttons/pairwatch.png';
import statusIcon from '../../../../assets/images/Fireboard/menu_buttons/status.png';
import scantopay from "../../../../assets/images/Fireboard/action_buttons/scantopay_white.png";
import texttopaydollar from "../../../../assets/images/Fireboard/action_buttons/texttopay_white.png";
import texttopayeuro from "../../../../assets/images/Fireboard/action_buttons/texttopayeuro_white.png";
import location from "../../../../assets/images/Fireboard/action_buttons/location_white.png";
import manager from "../../../../assets/images/Fireboard/action_buttons/preauth_white.png";
import diagnostics from '../../../../assets/images/Fireboard/menu_buttons/diagnostics.png';
import settings from '../../../../assets/images/Fireboard/settings.png';
import merge from '../../../../assets/images/Fireboard/merge.png';
import sensorGroupImg from '../../../../assets/images/Fireboard/sensorGroup.svg';
import sensorImg from '../../../../assets/images/Fireboard/action_buttons/sensor.png';
import productionRateIcon from '../../../../assets/images/Fireboard/menu_buttons/productionRate.png';
import switchModeIcon from '../../../../assets/images/Fireboard/menu_buttons/switchModeIcon.png';
import launchIcon from '../../../../assets/images/Fireboard/menu_buttons/launchNew.png';
import futureOrderIcon from '../../../../assets/images/Fireboard/menu_buttons/futureOrderIcon.png';
import drawIcon from "../../../../assets/images/TMS/draw.png";
import classNames from "classnames";
import EventEmitter from '../../../../util/event-emitter';
import Button from '../../../../components/Button';
import FireboardUtils from '../../../../util/fireboard-util';
import strings from '../../../../globalization';
import { SingleDropdown, MultiDropdown } from '../../../../components/Dropdowns';

const audio = new Audio(mp3File);
audio.loop = true;

export default function Header(props) {
    // props
    const status = constants.status;
    const CURB_SIDE = 'Curbside';
    const ONLINE = 'Online';
    const WALK_UP = 'Walk up';
    const TEXT_TO_PAY = 'Call in';
    const PREP_TIME = 'Prep Time';
    const PRODUCTION = 'Production';
    const PRE_AUTH = 'Pre Auth';

    const {
        orderTypes,
        orderType,
        onOrderTypeChange,
        snoozeEnabled,
        snoozeNotifications,
        notificationCount,
        notificationControlEnabled,
        countStatus,
        totalNotificationsCount,
        showNotifications,
        selectedDate,
        onOpenSearchBox,
        isFutureOrderType,
        showCalendar,
        curbCount,
        onlineCount,
        walkupCount,
        textToPayCount,
        curbPendingCount,
        onlinePendingCount,
        walkupPendingCount,
        textToPayPendingCount,
        preAuthCount,
        prepTime,
        production,
        onFooterIconPress,
        onChange,
        setNotifications,
        managerMode,
        onLogout,
        counters,
        currency = '$',
        orderStatusType,
        onOrderStatusChange,
        onClickBulkPreAuth,
        currentView,
        onOpenSelectModePopup,
        storeInfo,
        activeCheckFilter,
        fbVenueMode,
        multipleStores,
        selectedVenueStore,
        onChangeVenueStore,
    } = props;

    const [blinkAnim, setBlinkAnim] = useState(false);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [selectedAction, setSelectedAction] = useState('');
    const allowFutureOrder = isFutureOrderType && selectedDate;
    const showStoreDropdown = (fbVenueMode && !allowFutureOrder);

    useEffect(() => {
        if (notificationControlEnabled && notificationCount > 0) {
            if (!snoozeEnabled) {
                if (!window.ReactNativeWebView)
                    audio.play();
                else
                    EventEmitter.playAudio(true);
            }
            setBlinkAnim(true);
            return () => {
                if (!window.ReactNativeWebView)
                    audio && audio.pause();
                else
                    EventEmitter.playAudio(false);
                setBlinkAnim(false);
            };
        }
    }, [notificationControlEnabled, snoozeEnabled, notificationCount]);

    const getDropdowns = () => {
        let orderTypeList = [...orderTypes];
        if (activeCheckFilter === 'sensorGroup' && Array.isArray(orderTypeList) && orderTypeList.length) {
            if (orderTypeList.includes('All')) {
                orderTypeList = orderTypeList.filter(it => it !== 'All');
            }
            orderTypeList.sort(FireboardUtils.sortByValue);
            orderTypeList.unshift('All');
        }

        const dropdownWidth = managerMode
            ? showStoreDropdown ? 19 : 26
            : showStoreDropdown ? 21 : 28;

        return (
            <React.Fragment>
                <div className={styles.dropdownWrapper}>
                    <MultiDropdown
                        value={orderStatusType}
                        closeMenuOnSelect={false}
                        onChange={onOrderStatusChange}
                        options={status}
                        placeholder="Please Select"
                        width={dropdownWidth}
                    />
                </div>
                <div className={styles.dropdownWrapper}>
                    <MultiDropdown
                        value={orderType}
                        closeMenuOnSelect={false}
                        onChange={onOrderTypeChange}
                        options={orderTypeList.map(t => ({ value: t, label: t }))}
                        placeholder="Please Select"
                        width={dropdownWidth}
                    />
                </div>
            </React.Fragment>
        );
    };

    const getNotificationImage = () => {
        if (showNotifications) {
            if (notificationCount > 0) {
                return notificationUnSelectedFilled;
            }
            return notificationUnSelectedUnFilled;
        }
        if (notificationCount > 0) {
            return notificationUnSelectedFilled;
        }

        return notificationUnSelectedUnFilled;
    }

    const getSnoozeIcon = () => {
        if (notificationControlEnabled && notificationCount > 0) {
            if (!snoozeEnabled) {
                return (
                    <div className={styles.col2SubViewBell}>
                        <img alt="snooze" className={styles.snoozeIcon} src={snooze} onClick={snoozeNotifications} />
                    </div>
                );
            }
        }
    };

    const source = blinkAnim ? notificationGif : getNotificationImage();

    const checkVisibility = (name) => {
        return !counters.includes(name);
    }

    const getPrepProdInfo = () => {
        const isPrepVisible = checkVisibility(PREP_TIME);
        const isProdVisible = checkVisibility(PRODUCTION);
        let prepProd = {};
        if (isPrepVisible && isProdVisible) {
            prepProd = {
                name: 'Prep/Prod',
                value: `${prepTime}/${production}`,
            }
        } else if (isPrepVisible) {
            prepProd = {
                name: 'Prep',
                value: prepTime,
            }
        } else if (isProdVisible) {
            prepProd = {
                name: 'Prod',
                value: production,
            }
        }
        return prepProd;
    };

    const getIcon = type => {
        switch (type) {
            case "managerLogin": return manager;
            case "pairWatch": return pairwatch;
            case "marketplaceStatus": return statusIcon;
            case "checkIn": return location;
            case "channels": return channels;
            case "textToPay": return currency === '£' ? texttopayeuro : texttopaydollar;
            case "bulkTextToPay": return currency === '£' ? texttopayeuro : texttopaydollar;
            case "settings": return filters;
            case "payNow": return scantopay;
            case "diagnostics": return diagnostics;
            case "outOfStock": return outofstock;
            case "about": return info;
            case "sort": return settings;
            case "networkLogs": return settings;
            case "tileView": return graphicalImg;
            case "tableMerge": return merge;
            case "employeeAssignment": return merge;
            case "layoutView": return graphicalImg;
            case "sensorGroups": return sensorGroupImg;
            case "sensors": return sensorImg;
            case "productionRate": return productionRateIcon;
            case "launchExternalApp": return launchIcon;
            case "syncChecks": return resyncImg;
            case 'layoutDesign': return drawIcon;
            case "futureOrders": return futureOrderIcon;
            default: return null;
        }
    };

    const getMenuIconStyle = type => {
        switch (type) {
            case 'sensors': return styles.sensorIcon;
            default: return styles.menuIcon;
        }
    };

    const isMenuVisible = type => {
        if (!type) return false;
        switch (type) {
            case 'launchExternalApp': {
                if (storeInfo?.thirdPartyAppName && storeInfo?.thirdPartyAppUrl)
                    return true;
                return false;
            }
            default: return true;
        }
    };

    const getMenuName = menu => {
        switch (menu.type) {
            case 'launchExternalApp': {
                return storeInfo?.thirdPartyAppName;
            }
            case 'tileView': {
                return currentView === 'card' ? 'List View' : 'Tile View';
            }
            default: return menu?.name;
        }
    };

    const renderOverlayContent = () => {
        return (
            <div className={styles.overlayContentContainer}>
                <div className={styles.tooltipBtnWrapper}>
                    {constants.tooltipColumns1.map(tooltip => {
                        const { type: fType } = tooltip;
                        const disabled = managerMode && fType === 'managerLogin';
                        return (
                            <div
                                className={classNames({
                                    [styles.footerItem]: true,
                                    [styles.highligthtedAction]: selectedAction === fType && !disabled,
                                    [styles.disabledButton]: disabled
                                })}
                                key={`first-${fType}`}
                                onClick={() => {
                                    if (!disabled) {
                                        onFooterIconPress(fType);
                                        setTooltipVisible(false);
                                    }
                                }}
                                onMouseEnter={() => setSelectedAction(fType)}
                                onMouseLeave={() => setSelectedAction('')}
                            >
                                <div className={styles.imgWrapper}>
                                    <img src={getIcon(fType)} className={styles.menuIcon} />
                                </div>
                                <span className={classNames({ [styles.tooltipTextStyle]: true, [styles.disabledTxt]: disabled })}>{getMenuName(tooltip)}</span>
                            </div>
                        );
                    })}
                </div>
                <div className={styles.tooltipBtnWrapper}>
                    {constants.tooltipColumns2.map(tooltip => {
                        const { type: sType } = tooltip;
                        return (
                            isMenuVisible(sType) && (
                                <div
                                    className={classNames({
                                        [styles.footerItem]: true,
                                        [styles.highligthtedAction]: selectedAction === sType
                                    })}
                                    key={`second-${sType}`}
                                    onClick={() => {
                                        onFooterIconPress(sType);
                                        setTooltipVisible(false);
                                    }}
                                    onMouseEnter={() => setSelectedAction(sType)}
                                    onMouseLeave={() => setSelectedAction('')}
                                >
                                    <div className={styles.imgWrapper}>
                                        <img src={getIcon(sType)} className={getMenuIconStyle(sType)} />
                                    </div>
                                    <span className={styles.tooltipTextStyle}>{getMenuName(tooltip)}</span>
                                </div>
                            )
                        )
                    })}
                </div>
            </div>
        );
    };

    const storesDropdown = () => {
        return (
            <div className={styles.dropdownWrapper}>
                <SingleDropdown
                    value={selectedVenueStore}
                    closeMenuOnSelect={true}
                    onChange={onChangeVenueStore}
                    options={multipleStores}
                    placeholder="Please Select"
                    width={15}
                />
            </div>
        );
    };

    return (
        <div className={styles.header}>
            <div className={styles.leftContainer}>
                {managerMode
                    ? <span className={styles.preauthLabel}>{strings.preAuthLabel}</span>
                    : null
                }
                {showStoreDropdown ? storesDropdown() : null}
                {!allowFutureOrder ? getDropdowns() : <span className={styles.futureLabel}>Future Orders</span>}
                <img src={search} className={styles.headerIcon} alt="search" onClick={onOpenSearchBox} />
                {allowFutureOrder ? <img src={calendarImage} className={styles.headerIcon} alt="calendar" onClick={showCalendar} /> : null}
                <div className={styles.col2SubViewBell}>
                    <img onClick={setNotifications} className={styles.notIcon} src={source} key={source} alt="source" />
                    <div className={styles.notificationCountStyle}>
                        <span style={{ color: showNotifications && notificationCount !== 0 ? 'white' : 'black' }} className={[styles.notificationCountStyleText].join(' ')}>
                            {totalNotificationsCount}
                        </span>
                    </div>
                </div>
                {getSnoozeIcon()}
                <Tooltip
                    placement="bottomLeft"
                    visible={tooltipVisible}
                    overlay={renderOverlayContent()}
                    trigger={"click"}
                    overlayInnerStyle={{ padding: "0.93vh" }}
                    onVisibleChange={(visible) => setTooltipVisible(visible)}
                >
                    <img
                        data-tip="Settings"
                        src={option} className={styles.footerIcon} alt="settings" />
                </Tooltip>
                <img onClick={onOpenSelectModePopup} src={switchModeIcon} className={styles.footerIcon} alt="switch" />
            </div>
            {managerMode ? (
                <div className={styles.col2StyleMgr}>
                    <span className={styles.managerText}>** MANAGER ** </span>
                    <Button
                        key="submitBatch"
                        className={styles.bulkPreAuthBtn}
                        onClick={onClickBulkPreAuth}
                    >
                        <span className={styles.bulkPreAuthTxt}>{strings.bulkPreAuth}</span>
                    </Button>
                    <img onClick={onLogout} className={styles.logoutStyle} src={logoutImage} alt="source" />
                </div>
            ) : (
                <div className={styles.countContainer}>
                    <HeaderCount
                        header={PRE_AUTH}
                        color={'black'}
                        count={preAuthCount}
                        showStopper={false}
                        visible={checkVisibility(PRE_AUTH)}
                        type="preauth"
                    />
                    <HeaderCount
                        header={CURB_SIDE}
                        color={curbCount > 0 ? 'green' : 'black'}
                        count={curbPendingCount}
                        showStopper={!countStatus.curbside}
                        visible={checkVisibility(CURB_SIDE)}
                        type="curbside"
                    />
                    <HeaderCount
                        header={ONLINE}
                        color={onlineCount > 0 ? 'green' : 'black'}
                        count={onlinePendingCount}
                        showStopper={!countStatus.online}
                        visible={checkVisibility(ONLINE)}
                        type="online"
                    />
                    <HeaderCount
                        header={TEXT_TO_PAY}
                        color={textToPayCount > 0 ? 'green' : 'black'}
                        count={textToPayPendingCount}
                        visible={checkVisibility(TEXT_TO_PAY)}
                        showStopper={false}
                    />
                    <HeaderCount
                        header={WALK_UP}
                        color={walkupCount > 0 ? 'green' : 'black'}
                        count={walkupPendingCount}
                        showStopper={!countStatus.walkup}
                        visible={checkVisibility(WALK_UP)}
                        type="walkup"
                    />
                    <HeaderCount
                        header={getPrepProdInfo()?.name}
                        color="black"
                        count={getPrepProdInfo()?.value}
                        showStopper={false}
                        visible={checkVisibility(PREP_TIME) || checkVisibility(PRODUCTION)}
                        type="prepTime"
                    />
                </div>
            )}
        </div>
    );
}

const HeaderCount = countProps => {
    const { color, count, showStopper, header, type, visible } = countProps;
    if (!visible) return null
    return (
        <div className={styles.col2ProdSubView}>
            <span className={styles.subViewProdTextStyle}>
                {header}
            </span>
            <span className={styles.subViewCountStyle} style={{ color }}>{count}</span>
            {showStopper ? <img src={unpaidIcon} className={styles.countStopper} alt="unpaid" /> : null}
        </div>
    );
};